import { useTranslation } from 'react-i18next';
import type { UserPublicProfile } from '@user/PublicProfile';
import { UserIcon } from '@framework/ui/atoms/UserIcon';
import { classNames } from '@framework/utils';

type Props = {
  profiles: UserPublicProfile[];
  numberOfDisplayIcons: number;
  className?: string;
};

export const MemberIconList: React.FC<Props> = ({ profiles, numberOfDisplayIcons, className }: Props) => {
  const { t } = useTranslation();
  return (
    <div className={classNames('flex items-end justify-end', className || '')}>
      {profiles.slice(0, numberOfDisplayIcons).map((profile) => (
        <UserIcon key={profile.id} {...profile} size="medium" />
      ))}
      {profiles.length > numberOfDisplayIcons && (
        <span className="pl-1 text-sm">
          {t('workspace.memberIconList.others', { count: profiles.length - numberOfDisplayIcons })}
        </span>
      )}
    </div>
  );
};
